import { type Address, isEvmAddress } from "./inputs"
import { toLowerCase } from "./string"

export const NULL_ADDRESS = "0x0000000000000000000000000000000000000000"
export const NULL_ADDRESS_DEAD = "0x00000000000000000000000000000000000dEaD"

export const normalizeAddress = (address: Address): Address => {
  if (isEvmAddress(address, { strict: false })) {
    return toLowerCase(address)
  }
  return address
}

export const isAddressEqual = (
  a: string | null | undefined,
  b: string | null | undefined,
) => {
  if (!(a && b)) {
    return false
  }

  if (
    isEvmAddress(a, { strict: false }) ||
    isEvmAddress(b, { strict: false })
  ) {
    return a.toLowerCase() === b.toLowerCase()
  }

  return a === b
}

export const isNullAddress = (address: string | null | undefined) => {
  if (!address) {
    return false
  }

  return (
    isAddressEqual(address, NULL_ADDRESS) ||
    isAddressEqual(address, NULL_ADDRESS_DEAD)
  )
}
